import "./PrivacyPolicy.css";
const PrivacyPolicy = () => {
  return (
    <div className="privacypolicycontainer">
      <h2>Privacy Policy of Kondisyon</h2>

      <p>
        MAJE, Inc. operates the app Kondisyon, which provides the assistance to
        all users in the Philippines.
      </p>

      <p>
        This page is used to inform app users regarding our policies with the
        collection, use, and disclosure of Personal Information to our partnered
        Government agencies.
      </p>

      <p>
        If you choose to use our service, then you agree to the collection and
        use of information in relation with this policy. The Personal
        Information that we collect are used for providing and improving the
        assistance to all users specifically during disasters. We will not use
        or share your information with anyone except as described in this
        Privacy Policy.
      </p>

      <h6>
        We collect information when you choose to give it to us. This includes:
      </h6>

      <ul>
        <li>contact information like name, email address and phone number;</li>
        <li>the information you use to create a profile; and;</li>
        <li>information you provide to us when you contact Kondisyon.</li>
      </ul>

      <p>
        The terms used in this Privacy Policy have the same meanings as in our
        Terms and Conditions, which is accessible at our login page, unless
        otherwise defined in this Privacy Policy.
      </p>

      <h4>Information Collection and Use</h4>
      <p>
        For a better experience while using our Service, we may require you to
        provide us with certain personally identifiable information, including
        but not limited to your phone number, name and email address. The
        information that we collect will be used to contact and identify you.
      </p>

      <h4>Log Data</h4>
      <p>
        We want to inform you that whenever you visit our app, we collect
        information that your browser sends to us that is called Log Data. This
        Log Data may include information such as your computer's Internet
        Protocol (“IP”) address, browser version, pages of our Service that you
        visit, the time and date of your visit, the time spent on those pages,
        and other statistics.
      </p>

      <h4>Cookies</h4>
      <p>
        Cookies are files with small amount of data that is commonly used an
        anonymous unique identifier. These are sent to your browser from the
        website that you visit and are stored on your computer's hard drive.
      </p>

      <h4>Service Providers</h4>
      <h6>
        We may employ third-party companies and individuals due to the following
        reasons:
      </h6>
      <ul>
        <li>To facilitate our Service;</li>
        <li>To provide the Service on our behalf;</li>
        <li>To perform Service-related services; or</li>
        <li>To assist us in analyzing how our Service is used.</li>
      </ul>
      <p>
        We want to inform our Service users that these third parties have access
        to your Personal Information. The reason is to perform the tasks
        assigned to them on our behalf. However, they are obligated not to
        disclose or use the information for any other purpose.
      </p>

      <h4>Security</h4>
      <p>
        We value your trust in providing us your Personal Information, thus we
        are striving to use commercially acceptable means of protecting it. But
        remember that no method of transmission over the internet, or method of
        electronic storage is 100% secure and reliable, and we cannot guarantee
        its absolute security.
      </p>

      <h4>Children's Privacy</h4>

      <p>
        Our Services do also address anyone under the age of 18. We collect
        personal identifiable information from children under 18 to respond to
        disasters.
      </p>

      <h4>Changes to This Privacy Policy</h4>
      <p>
        We may update our Privacy Policy from time to time. Thus, we advise you
        to review this page periodically for any changes. We will notify you of
        any changes by posting the new Privacy Policy on this page. These
        changes are effective immediately, after they are posted on this page.
      </p>

      <h4>Contact Us</h4>
      <p>
        If you have any questions or suggestions about our Privacy Policy, do
        not hesitate to contact us.
      </p>
    </div>
  );
};

export default PrivacyPolicy;
